<template>
<Layout>
  <div class="px-4 sm:px-0">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
        <div>
            <h1 class="text-3xl font-bold text-gray-900">Job Management</h1>
            <p class="mt-2 text-gray-600">Manage Job assignments and bookings</p>
        </div>
        <div class="flex flex-col sm:flex-row gap-2 mt-4 sm:mt-0">
          <input
            v-model="selectedDate"
            type="date"
            class="form-control"
            @change="fetchJobsByDate"
          />
          <button class="btn inline-flex items-center bg-black text-white hover:bg-gray-800 w-60" @click="openAddForm">
            <Plus class="h-4 w-4 mr-2" />
            <span class="leading-none">Add Job</span>
          </button>
          <!-- <button class="btn inline-flex items-center bg-black text-white hover:bg-gray-800 w-60" >
            <Atom class="h-4 w-4 mr-2" />
            <span class="leading-none">Auto Assign</span>
          </button> -->

          <!-- <button class="btn inline-flex items-center bg-black text-white hover:bg-gray-800 w-60" @click="uploadExcel">
            <FileUp class="h-4 w-4 mr-2" />
            <span class="leading-none">Upload</span>
          </button> -->
        </div>
        

    </div>
      <p class="text-sm text-gray-500 mt-2">
        Currently assigning is for location based only
      </p>   

    <!-- Search -->
    <div class="mb-6">
        <div class="relative">
            <Search
            class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4"
            style="display: inline-block;"
            />
            <input
            v-model="searchTerm"
            placeholder="Search Jobs..."
            class="w-full pl-10 pr-4 py-2 h-10 border rounded text-sm"
            />
        </div>
    </div>

    <!-- Job List -->
    <div class="grid gap-6">
    <div
        v-for="job in filteredJobs"
        :key="job.id"
        class="card hover:shadow-lg transition-shadow bg-white rounded-lg overflow-hidden"
    >
    <!-- Header -->
    <div class="card-header px-6 pt-6 pb-4 bg-white border-none">
      <div class="flex justify-between items-start">
        <div class="flex items-start space-x-3">
          <div class="p-2 bg-blue-100 rounded-lg">
            <MapPin class="h-5 w-5 text-blue-600" />
          </div>
          <div>
            <h2 class="text-xl">{{ job.title }}</h2>
            <p class="text-gray-600">{{ job.client }}</p>
            <p class="text-sm text-gray-500">Job ID: {{ job.jobId }}</p>
            <p class="text-sm text-gray-500">Department: {{ job.department }}</p>
            <span :class="'badge mt-2 ' + getStatusColor(job.status)">
              {{ job.status }}
            </span>
          </div>
        </div>
        <div class="flex space-x-2">
          <button class="btn-outline-icon" @click="openEditForm(job)">
            <Edit class="h-4 w-4" />
          </button>
          <button class="btn-outline-icon" @click="handleDeleteJob(job.id)">
            <Trash2 class="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="card-content px-6 pb-6 pt-4 bg-white">
      <div class="grid grid-cols-1 md:grid-cols-2  gap-4 mb-4">
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Start Location</h4>
          <p class="text-sm text-gray-600">{{ job.startLocation }}</p>
        </div>
        <div>
          <h4 class="font-medium text-gray-900 mb-1">End Location</h4>
          <p class="text-sm text-gray-600">{{ job.endLocation }}</p>
        </div>
        <!-- <div>
          <h4 class="font-medium text-gray-900 mb-1">Budget</h4>
          <p class="text-sm text-gray-600">{{ job.budget }}</p>
        </div> -->
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Job Date</h4>
          <p class="text-sm text-gray-600">{{ job.jobDate }}</p>
        </div>
        <div>
    <h4 class="font-medium text-gray-900 mb-1">Job Time</h4>
    <p class="text-sm text-gray-600">{{ job.jobTime || 'Not set' }}</p>
  </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Job Start</h4>
          <p class="text-sm text-gray-600">{{ job.jobStart }}</p>
        </div>
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Job End</h4>
          <p class="text-sm text-gray-600">{{ job.jobEnd }}</p>
        </div>
      </div>
      <!-- Location Based + Notifications -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Location Based</h4>
          <p class="text-sm text-gray-600">
            <span :class="job.locationBased ? 'text-green-600' : 'text-gray-500'">
              {{ job.locationBased ? 'Enabled' : 'Disabled' }}
            </span>
          </p>
        </div>
        <div>
          <h4 class="font-medium text-gray-900 mb-1">Notifications</h4>
          <p class="text-sm text-gray-600">
            <span :class="job.notifications ? 'text-green-600' : 'text-gray-500'">
              {{ job.notifications ? 'Enabled' : 'Disabled' }}
            </span>
          </p>
        </div>
      </div>

      <div class="mb-4">
        <h4 class="font-medium text-gray-900 mb-2">Assigned Employee</h4>
        <div class="flex flex-wrap gap-2">
          <span
            v-for="(employee, index) in job.assignedEmployees"
            :key="index"
            class="badge-secondary"
          >
            {{ employee }}
          </span>
        </div>
      </div>

            <div>
                <h4 class="font-medium text-gray-900 mb-2">Description</h4>
                <p class="text-sm text-gray-600">{{ job.description }}</p>
            </div>
            </div>
        </div>
    </div>


    <!-- Job Form Dialog -->
    <JobForm
      :isOpen="isFormOpen"
      :onClose="() => { isFormOpen = false }"
      :onSubmit="editingJob ? handleUpdateJob : handleAddJob"
      :job="editingJob"
    />
  </div>
</Layout>

</template>

<script>
import { Plus, Search, Edit, Trash2, MapPin} from "lucide-vue-next";
import JobForm from "@/components/JobForm.vue";
import Layout from '../components/Layout.vue';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";

export default {
  components: { Plus, Search, Edit, Trash2, MapPin, JobForm,Layout },
  data() {
    return {
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      searchTerm: "",
      isFormOpen: false,
      editingJob: null,
      selectedDate:"",
      jobs: [], 
      employees:[]
    };
  },
  computed: {
    filteredJobs() {
      return this.jobs.filter((job) => {
        const search = this.searchTerm.toLowerCase();
        return (
          job.title.toLowerCase().includes(search) ||
          job.client.toLowerCase().includes(search) ||
          job.jobId.toLowerCase().includes(search) ||
          job.startLocation.toLowerCase().includes(search) ||
          job.endLocation.toLowerCase().includes(search) ||
          job.assignedEmployees.some((emp) => emp.toLowerCase().includes(search))
        );
      });
    },
  },
  methods: {
    getEmployeeName(id) {
  if (!Array.isArray(this.employees) || this.employees.length === 0) {
    return "Unknown";
  }
  const found = this.employees.find(e => e.id === id);
  return found ? found.name : "Unknown";
},
    openAddForm() {
      this.editingJob = null;
      this.isFormOpen = true;
    },
    openEditForm(job) {
      this.editingJob = job;
      this.isFormOpen = true;
    },
     async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');
      const token = await user.getIdToken();
      return { Authorization: token };
    },
    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            const token = await user.getIdToken();
            resolve(token);
          } else {
            router.push("/");
            reject("Not logged in");
          }
        });
      });
    },
    async fetchJobsByDate() {
      try {
        const headers = await this.getAuthHeader();


        // Call API with selected date
        const res = await axios.get(`${this.apiURL}/api/jobs`, {
          params: { date: this.selectedDate },
          headers,
        });

        if (res.status === 200) {
          this.jobs = res.data.map(job => ({
            ...job,
            jobDate: job.jobDate?.split("T")[0] || "",

            // ✅ Added new fields
            jobTime: job.jobTime || "", 
            locationBased: job.locationBased || false,
            notifications: job.notifications || false,

            jobStart: job.jobStart
              ? new Date(job.jobStart).toLocaleString("en-SG", { timeZone: "Asia/Singapore" })
              : "",
            jobEnd: job.jobEnd
              ? new Date(job.jobEnd).toLocaleString("en-SG", { timeZone: "Asia/Singapore" })
              : "",

            // Replace assigned employee IDs with their names
            assignedEmployees: job.assignedEmployees.map(id => this.getEmployeeName(id)),
          }));
        } else {
          this.jobs = [];
          this.toast?.error(res.data.message || "Failed to fetch jobs");
        }
      } catch (err) {
        console.error("Error fetching jobs:", err);
        this.jobs = [];
        this.toast?.error("Server error while fetching jobs.");
      }
    },

    handleAddJob() {
      this.fetchJobsByDate()
      // const newJob = {
      //   ...jobData,
      //   id: Date.now().toString(),
      // };
      // this.jobs.push(newJob);
      // this.isFormOpen = false;
      // alert("Job added successfully!");
    },
    handleUpdateJob() {
      this.fetchJobsByDate()

      // if (!this.editingJob) return;
      // this.jobs = this.jobs.map((job) =>
      //   job.id === this.editingJob.id ? { ...jobData, id: this.editingJob.id } : job
      // );
      // this.editingJob = null;
      // this.isFormOpen = false;
      // alert("Job updated successfully!");
    },
    async handleDeleteJob(jobId) {
      try {
        const headers = await this.getAuthHeader();

        const res = await axios.delete(`${this.apiURL}/api/jobs/${jobId}`, {
          headers
        });

        if (res.data.code === 200) {
          this.toast?.success("Job deleted successfully!");
          await this.fetchJobsByDate(); // Refresh job list
        } else {
          this.toast?.error(res.data.message || "Failed to delete job.");
        }
      } catch (err) {
        console.error("Error deleting job:", err);
        this.toast?.error("Server error while deleting job.");
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "assigned":
          return "bg-blue-100 text-blue-800";
        case "active":
          return "bg-green-100 text-green-800";
        case "ended":
          return "bg-gray-100 text-gray-800";
        case "cancelled":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    async fetchEmployees() {
      try {
        const token = await this.checkAuthState();
        const res = await axios.get(`${this.apiURL}/api/employees`, {
          headers: { Authorization: token },
        });
        this.employees = res.data.employees;
      } catch (err) {
        console.error("Error fetching employees:", err);
      }
    }
  },
  async mounted(){
    const sgOffset = 8 * 60; // Singapore is UTC+8
    const now = new Date(new Date().getTime() + (sgOffset - new Date().getTimezoneOffset()) * 60000);
    this.selectedDate = now.toISOString().split("T")[0];
    this.userID = this.$store.getters.getUserId;
    await this.checkAuthState();
    this.fetchEmployees().then(() => {
    this.fetchJobsByDate(); // only fetch jobs AFTER employees ready
  });
  }
};
</script>
